module.exports = __webpack_public_path__ + "static/media/Asset 10.1@3x.b1650615.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 10.1@3x.png
// module id = 2407
// module chunks = 0